import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import jsPDF from 'jspdf';
import autoTable, { CellInput } from 'jspdf-autotable';

import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

import { AuthenticationService } from '../../core/services/auth.service';
import { AuthfakeauthenticationService } from '../../core/services/authfake.service';
import { environment } from '../../../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { Permiso } from 'src/app/entities/Enums/permiso.enum';
import { TraspasoSaldoService } from 'src/app/shared/services/traspaso-saldo.service';
import { NumberFormatPipe } from 'src/app/pages/cell-payment-service/pipe.service';
import { SaldoService } from 'src/app/pages/punto-venta/vista-compania/compartirSaldo.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SucursalService } from 'src/app/shared/services/sucursal.service';
import { MsgConfigService } from 'src/app/shared/services/msg-config.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  providers: [NumberFormatPipe]
})

/**
 * Topbar component
 */
export class TopbarComponent implements OnInit {

  element;
  configData;
  cookieValue;
  flagvalue: any;
  countryName: any;
  valueset;
  public imagenPerfil: string;
  public nombre: string;
  public apellidoPaterno: string;
  public totalAsignado: number = 0;
  public totalGastado: number = 0;
  public configuracionForm: FormGroup;
  public mensajeConfig: Array<any> = []

  constructor(@Inject(DOCUMENT) private document: any,
    private saldoService: SaldoService,
    private saldo: TraspasoSaldoService,
    private router: Router,
    private msgConfigServ: MsgConfigService,
    private authService: AuthenticationService,
    private authFackservice: AuthfakeauthenticationService,
    public languageService: LanguageService,
    public translate: TranslateService,
    private permissionsService: NgxPermissionsService,
    private user: AuthenticationService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    public _cookiesService: CookieService) {
  }

  irPuntoVenta() {
    this.router.navigateByUrl('/recargas')
  }
  listLang = [
    { text: 'Español', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
    // { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    // { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' },
    // { text: 'Italian', flag: 'assets/images/flags/italy.jpg', lang: 'it' },
    // { text: 'Russian', flag: 'assets/images/flags/russia.jpg', lang: 'ru' },
  ];

  openMobileMenu: boolean;

  irPerfil() {
    this.router.navigateByUrl('/contacts/profile')
  }

  hasPermission(permission: string): boolean {
    return this.permissionsService.getPermission(permission) !== undefined;
  }

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();
  public showText: boolean = false;
  public showSwitchs: boolean;
  public showConfiguracion: boolean;
  public rol: string;

  ngOnInit() {
    this.initForm()
    // this.getMensajeConfig()
    this.traerSucursal();
    this.saldoService.getNewRecharges().subscribe((newRecharge) => {
      // console.log(newRecharge)
      // this.obtenerSaldo();
      // this.obtenerSaldo();
    });
    // this.suscribirseAlCambioDeSaldo();
    // this.obtenerSaldo();
    // this.obtenerPermisos();
    this.openMobileMenu = false;
    this.element = document.documentElement;

    const user = this.user.getUser();
    this.nombre = user.user.nombre;
    this.apellidoPaterno = user.user.apellidoPaterno;
    this.rol = user.user.rol.nombre

    this.authService.imagenPerfil$.subscribe((newImageUrl: string) => {
      console.log(newImageUrl);
      
      this.imagenPerfil = newImageUrl;
    });

    this.imagenPerfil = user.user.imagenPerfil;

    if (user.permisos.find(p => p.idPermiso == "57")) {
      this.showText = true;
    } else {
      this.showText = false;
    }

    if (user.permisos.find(p => p.idPermiso == "29")) {
      this.showConfiguracion = true;
    } else {
      this.showConfiguracion = false;
    }

    if (user.permisos.find(p => p.idPermiso == "58")) {
      this.showSwitchs = true;
    } else {
      this.showSwitchs = false;
    }

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3
    };

    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.valueset = 'assets/images/flags/us.jpg';
      }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }

    // this.totalizarSaldos();
  }

  centerModal(centerDataModal: any) {
    this.modalService.open(centerDataModal, { centered: true, windowClass: 'modal-holder' });
  }

  cerrarModal(modal: any) {
    modal.close('Modal cerrado por nuevo método');
  }

  public listaSucursales: Array<any> = [];

  initForm() {
    this.configuracionForm = this.fb.group({
      id: [],
      idSucursal: [null, Validators.required],
      mensaje: ['', Validators.required],
      soporte: ['', Validators.required],
    });
  }

  traerSucursal() {
    const user = this.user.getUser();
    this.listaSucursales.push(user.user.sucursal);
    if (this.listaSucursales.length > 0) {
      const primeraSucursal = this.listaSucursales[0];
      if(primeraSucursal) {
        this.configuracionForm.controls['idSucursal'].setValue(primeraSucursal.id);
      }
    }
  }

  suscribirseAlCambioDeSaldo(): void {
    this.saldoService.saldo$.subscribe((nuevoSaldo) => {
      this.showSaldo = nuevoSaldo.toFixed(2);
      // console.log('Saldo actualizado en Topbar:', this.showSaldo);
    });
  }


  public permisoVerSaldo: string;
  public permisoSwitch: string;
  obtenerPermisos() {
    // this.permisoVerSaldo = Permiso.VistaSaldo;
    // this.permisoSwitch = Permiso.ConsultaProvedores;

    const permisos = [
      this.permisoVerSaldo,
      this.permisoSwitch
    ];

    this.permissionsService.loadPermissions(permisos);
  }


  /**
   * Language set
   * @param text
   * @param lang
   * @param flag
   */
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  logout() {
    this.authService.logout();
  }


  public showSaldo: string = '0';
  public showMonto: boolean;
  public informacion: any;
  obtenerSaldo() {
    this.saldo.obtenerSaldo().subscribe({
      next: (response: any) => {
        if (response && response.monto !== null && response.monto !== undefined) {
          this.showSaldo = response.monto;
          // console.log('Saldo obtenido:', response);
        } else {
          // console.warn('Monto no está disponible en la respuesta:', response);
          this.showSaldo = '0.00';
        }
      },
      error: (err) => {
        // console.error('Error al obtener el saldo:', err);
        this.showSaldo = '0.00';
      }
    });
  }


  transform(value: any): string {
    return '$' + Number(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  }


  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  goSwitcheo() {
    this.router.navigateByUrl('/switcheo');
  }

  totalizarSaldos() {
    let data = JSON.parse(sessionStorage.getItem('user'));

    this.saldoService.totalizadorSaldos().subscribe((response) => {

      switch (data.user.idRol) {
        case '7': //ID CAJA
          this.totalAsignado = Number(response.asignadoCaja.TotalAsignado);
          this.totalGastado = Number(response.totalGastadoCaja[0].monto);
          break;
        case '5': //ID CADENA
          this.totalAsignado = Number(response.asignadoCadena.TotalAsignado);
          this.totalGastado = Number(response.totalGastadoCadena[0].monto);
          break;
        case '6': //IDSUCURSAL
          this.totalAsignado = Number(response.asignadoSucursal.TotalAsignado);
          this.totalGastado = Number(response.totalGastadoSucursal[0].monto);
          break;
        default:
          this.totalAsignado = 0;
          this.totalGastado = 0;
          break;
      }
    });
  }

  // getMensajeConfig() {
  //   this.msgConfigServ.obtenerMensajeConfig().subscribe(
  //     (response) => {
  //       this.mensajeConfig = response;
  //       // console.log(this.mensajeConfig);
  //       if(this.mensajeConfig.length >0 ) {
  //         this.configuracionForm.patchValue({
  //           id: this.mensajeConfig[0].Id,
  //           mensaje: this.mensajeConfig[0].Mensaje,
  //           soporte: this.mensajeConfig[0].Soporte,
  //         });
  //       }
  //     }
  //   )
  // }

  onSucursalChange(event: any, valor: string) {
    const selectedSucursalId = event.value;

  }

  // imprimir() {
  //   const doc = new jsPDF({
  //     unit: 'mm',   // Unidad en milímetros
  //     format: [75, 200] // Ancho 80mm, alto 200mm (ajustado según tu necesidad)
  //   });

  //   let yPosition = 10;  // Empieza en la parte superior de la página

  //   // Título del ticket (Nombre de la tienda o negocio)
  //   doc.setFontSize(16);
  //   doc.text("Tienda de Ejemplo", 14, yPosition);  
  //   yPosition += 10;  // Se mueve hacia abajo para el siguiente contenido

  //   // Dirección (opcional)
  //   doc.setFontSize(12);
  //   doc.text("Av. Ejemplo 123, Ciudad, País", 14, yPosition); 
  //   yPosition += 10;

  //   // Fecha y hora
  //   const fecha = new Date().toLocaleString();
  //   doc.setFontSize(10);
  //   doc.text(`Fecha: ${fecha}`, 14, yPosition);
  //   yPosition += 10;

  //   // Línea para separar encabezado del cuerpo del ticket
  //   doc.line(14, yPosition, 66, yPosition); // Línea para separar título de productos
  //   yPosition += 5; // Se deja un espacio después de la línea

  //   // Encabezado de la tabla de productos
  //   doc.setFontSize(10);
  //   doc.text("Producto", 14, yPosition);
  //   doc.text("Cantidad", 60, yPosition);
  //   doc.text("Precio", 70, yPosition);
  //   doc.text("Total", 80, yPosition);
  //   yPosition += 8;  // Se mueve hacia abajo para la lista de productos

  //   // Detalle de productos - Lista de productos del ticket
  //   const productos = [
  //     { nombre: "Producto A", cantidad: 2, precio: 100, total: 200 },
  //     { nombre: "Producto B", cantidad: 1, precio: 150, total: 150 },
  //     { nombre: "Producto C", cantidad: 3, precio: 80, total: 240 },
  //   ];

  //   productos.forEach(producto => {
  //     doc.text(producto.nombre, 14, yPosition);
  //     doc.text(`${producto.cantidad}`, 60, yPosition);
  //     doc.text(`$${producto.precio.toFixed(2)}`, 70, yPosition);
  //     doc.text(`$${producto.total.toFixed(2)}`, 80, yPosition);
  //     yPosition += 8; // Se separa cada fila de productos
  //   });

  //   // Línea para separar la lista de productos del resumen
  //   doc.line(14, yPosition, 66, yPosition); 
  //   yPosition += 5;  // Espacio para separación

  //   // Resumen de la compra
  //   doc.setFontSize(12);
  //   doc.text("Resumen de la compra", 14, yPosition);
  //   yPosition += 10;

  //   // Totales
  //   const totalCompra = productos.reduce((total, producto) => total + producto.total, 0);
  //   doc.text(`Total: $${totalCompra.toFixed(2)}`, 14, yPosition);
  //   yPosition += 10;

  //   // Método de pago (puedes agregarlo si lo necesitas)
  //   doc.text("Método de pago: Tarjeta de Crédito", 14, yPosition);
  //   yPosition += 10;

  //   // Pie del ticket
  //   doc.setFontSize(8);
  //   doc.text("Gracias por su compra. ¡Vuelva pronto!", 14, yPosition);
  //   const pdfBlob = doc.output('blob');
  //   const url = URL.createObjectURL(pdfBlob);

  //   // Guarda el PDF con un nombre
  //   const printWindow = window.open(url, '_blank');
  //   if (printWindow) {
  //     // Esperar a que el PDF cargue y luego imprimir automáticamente
  //     printWindow.addEventListener('load', () => {
  //       printWindow.print();
  //     });
  //   } else {
  //     console.error('No se pudo abrir la ventana para imprimir');
  //   }

  //   // doc.save('ticket_de_compra22.pdf');
  // }



  // async imprimir() {
  //   const userString = sessionStorage.getItem('user');
  //   const user = userString ? JSON.parse(userString) : null;
  //   const logoBase64 = user.user.cadena.imagenLogo;
  //   const nombreCadena = user.user.cadena.nombre;
  //   if (!logoBase64) {
  //     console.error('La imagen no está disponible en sessionStorage');
  //     return;
  //   }

  //   // Definir el logo y su altura
  //   const logoHeight = 20; // Altura del logo
  //   const logoWidth = 50;  // Ancho del logo

  //   // Calcular la altura total del contenido antes de crear el PDF
  //   let yPosition = logoHeight + 10; // Altura del logo + margen

  //   // Crear el PDF con el tamaño inicial
  //   const doc = new jsPDF({
  //     unit: 'mm',   // Unidad en milímetros
  //     format: [75, 297]  // A4 por defecto, el ancho será 75mm, y la altura se ajustará
  //   });

  //   // Insertar la imagen en el ticket
  //   doc.addImage(logoBase64, 'PNG', 10, 5, logoWidth, logoHeight);

  //   // Insertar el contenido
  //   doc.setFontSize(10);
  //   doc.setFont('helvetica', 'bold');

  //   // Centrar el texto "Tienda de Ejemplo"
  //   const tiendaText = nombreCadena;
  //   const tiendaTextWidth = doc.getTextWidth(tiendaText); // Obtiene el ancho del texto
  //   const xTienda = (75 - tiendaTextWidth) / 2;  // 75 es el ancho del documento
  //   doc.text(tiendaText, xTienda, yPosition); // Texto centrado
  //   yPosition += 5;

  //   doc.setFont('helvetica', 'normal');  // Restaurar la fuente y estilo normal

  //   // Añadir más contenido centrado (por ejemplo, dirección)
  //   const direccionText = "Av. Ejemplo 123, Ciudad, País";
  //   const direccionTextWidth = doc.getTextWidth(direccionText);
  //   const xDireccion = (75 - direccionTextWidth) / 2;
  //   doc.text(direccionText, xDireccion, yPosition);
  //   yPosition += 5;

  //   // Añadir más contenido (fecha, línea de separación, productos, etc.)
  //   // Añadir más contenido (fecha, línea de separación, productos, etc.)
  //   const fecha = new Date().toLocaleString();
  //   const fechaText = `Fecha: ${fecha}`;
  //   const fechaTextWidth = doc.getTextWidth(fechaText);
  //   const xFecha = (75 - fechaTextWidth) / 2;
  //   doc.text(fechaText, xFecha, yPosition);
  //   yPosition += 10;

  //   // Aquí podemos agregar más contenido si lo necesitas

  //   // Calcular la altura total del contenido
  //   const totalHeight = yPosition;

  //   // Verificar si el contenido se ajusta a la página
  //   if (totalHeight > 297) { // A4 tiene 297mm de alto
  //     doc.addPage(); // Si el contenido es mayor que una página, añade una nueva página
  //     // Volver a agregar contenido en la nueva página si es necesario
  //   }

  //   //imprimir
  //   doc.autoPrint();
  //   window.open(doc.output('bloburl'), '_blank');
  // }


  // guardarConfiguracion(modal: any) {
  //   this.configuracionForm.removeControl('idSucursal');
  //   const saveForm = this.configuracionForm.value;
  //   if (this.mensajeConfig.length > 0) {
  //     const data = {
  //       id: Number(saveForm.id),
  //       soporte: saveForm.soporte,
  //       mensaje: saveForm.mensaje
  //     };
  //     this.msgConfigServ.actualizarMensajeConfig(data).subscribe(
  //       (response) => {
  //         Swal.fire({
  //           title: 'Actualizado',
  //           text: 'Se ha actualizado la configuración correctamente',
  //           icon: 'success',
  //           confirmButtonText: 'Aceptar'
  //         }).then(() => {
  //           this.cerrarModal(modal); 
  //         });
  //       }
  //     );
  //   } else {
  //     this.configuracionForm.removeControl('id');
  //     this.msgConfigServ.registrarMensajeConfig(saveForm).subscribe(
  //       (response) => {
  //         Swal.fire({
  //           title: 'Registrado',
  //           text: 'Se ha registrado la configuración correctamente',
  //           icon: 'success',
  //           confirmButtonText: 'Aceptar'
  //         }).then(() => {
  //           this.cerrarModal(modal);
  //         });
  //       }
  //     );
  //   }
  // } 


  async imprimir() {
    const userString = sessionStorage.getItem('user');
    const user = userString ? JSON.parse(userString) : null;
    const logoBase64 = user.user.cadena.imagenLogo;


    // Obtener la hora en formato 12 horas (AM/PM)
    const hora = new Date();
    let horas = hora.getHours();
    let minutos = hora.getMinutes();
    const ampm = horas >= 12 ? 'PM' : 'AM';

    // Convertir a formato de 12 horas
    horas = horas % 12;
    horas = horas ? horas : 12; // El 0 debe ser convertido a 12
    minutos = Number(String(minutos).padStart(2, '0')); // Asegurarse de que los minutos tengan dos dígitos

    // Crear la cadena de la hora en formato 12 horas
    const horaFormateada = `${horas}:${minutos} ${ampm}`;
    if (!logoBase64) {
      // console.error('La imagen no está disponible en sessionStorage');
      return;
    }

    // Crear el PDF
    const doc = new jsPDF({
      unit: 'mm', // Unidad en milímetros
      format: [75, 297]  // A4 en formato estrecho (75mm de ancho, 297mm de alto)
    });

    // Definir las posiciones y el tamaño del logo
    const logoHeight = 20;
    const logoWidth = 50;
    const yMargin = 0;  // Margen superior

    // Calcular la posición del logo centrado
    doc.addImage(logoBase64, 'PNG', (75 - logoWidth) / 2, yMargin, logoWidth, logoHeight);

    let yPosition = yMargin + logoHeight + 5; // Ajustar la posición después del logo

    // Nombre de la cadena en negrita y centrado
    doc.setFontSize(8);
    doc.setFont("helvetica", "bold");
    const nombreCadena = user.user.cadena.razonSocial;
    const nombreCadenaWidth = doc.getTextWidth(nombreCadena);
    const xNombre = (75 - nombreCadenaWidth) / 2;
    doc.text(nombreCadena, xNombre, yPosition);
    yPosition += 5;

    const sucursal = user.user.sucursal.nombre;
    // Dirección centrada
    doc.setFont("helvetica", "normal");
    const nombreSucursal = `Sucursal: ${sucursal}`;
    const sucursalWidth = doc.getTextWidth(nombreSucursal);
    const xDireccionSucursal = (75 - sucursalWidth) / 2;
    doc.text(nombreSucursal, xDireccionSucursal, yPosition);
    yPosition += 3;

    const direccion = "Dirección: Aquí iría la dirección";
    const direccionWidth = doc.getTextWidth(direccion);
    const xDireccion = (75 - direccionWidth) / 2;
    doc.text(direccion, xDireccion, yPosition);
    yPosition += 3;

    // Teléfono centrado
    const telefono = "Teléfono: Aquí iría el teléfono";
    const telefonoWidth = doc.getTextWidth(telefono);
    const xTelefono = (75 - telefonoWidth) / 2;
    doc.text(telefono, xTelefono, yPosition);
    yPosition += 5;

    // Línea divisoria
    doc.line(5, yPosition, 70, yPosition);
    yPosition += 5;

    // Título "Recarga Celular" centrado
    doc.setFont("helvetica", "bold");
    const recargaTexto = "VENTA RECARGA CELULAR";
    const recargaWidth = doc.getTextWidth(recargaTexto);
    const xRecarga = (75 - recargaWidth) / 2;
    doc.text(recargaTexto, xRecarga, yPosition);
    yPosition += 5;

    // Línea divisoria
    doc.line(5, yPosition, 70, yPosition);
    yPosition += 5;

    // Fecha, Caja y Cajero justificados
    doc.setFont("helvetica", "normal");
    const fecha = new Date().toLocaleDateString();  // DD-MM-YYYY
    doc.text(`Fecha:`, 10, yPosition);
    doc.text(fecha, 65, yPosition, { align: "right" });
    yPosition += 3;

    doc.setFont("helvetica", "normal");
    doc.text('Hora:', 10, yPosition);
    doc.text(horaFormateada, 65, yPosition, { align: "right" });
    yPosition += 3;

    const caja = "Caja 01";
    const cajero = "Nombre del cajero";
    doc.text('Caja:', 10, yPosition);
    doc.text(caja, 65, yPosition, { align: "right" });
    yPosition += 3;

    doc.text('Cajero:', 10, yPosition);
    doc.text(cajero, 65, yPosition, { align: "right" });
    yPosition += 3;

    // Línea divisoria
    doc.line(5, yPosition, 70, yPosition);
    yPosition += 5;

    // Detalle de productos (Descripción y Costo)
    doc.setFont("helvetica", "bold");
    const descripcionTitle = "Descripción:";
    const telfTitle = "Número";
    doc.text(descripcionTitle, 10, yPosition);
    doc.text(telfTitle, 65, yPosition, { align: "right" }); // Justificado a la derecha
    yPosition += 5;


    doc.setFont("helvetica", "normal");
    const descripcion = "Recarga Telcel";
    const telf = "5660113375";
    doc.text(descripcion, 10, yPosition);
    doc.text(telf, 65, yPosition, { align: "right" }); // Justificado a la derecha
    yPosition += 5;

    // Línea divisoria
    doc.line(5, yPosition, 70, yPosition);
    yPosition += 5;

    // Total en negrita y justificado
    doc.setFont("helvetica", "bold");
    const totalTexto = "MONTO";
    const totalCosto = "$100.00 MXN";
    doc.text(totalTexto, 10, yPosition);
    doc.text(totalCosto, 65, yPosition, { align: "right" }); // Justificado a la derecha
    yPosition += 5;

    // Línea divisoria
    doc.line(5, yPosition, 70, yPosition);
    yPosition += 10;

    // Mensaje de agradecimiento
    const mensajeGracias = "¡GRACIAS POR SU COMPRA!";
    const mensajeWidth = doc.getTextWidth(mensajeGracias);
    const xMensaje = (75 - mensajeWidth) / 2;
    doc.text(mensajeGracias, xMensaje, yPosition);

    yPosition += 20;
    // Imprimir el documento
    doc.autoPrint();
    window.open(doc.output('bloburl'), '_blank');
  }

}
